const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://quangninhprovince-api.cgis.asia/",
  },
  production: {
      api: "https://quangninhprovince-api.cgis.asia/",
  },
};

module.exports = apiEnvironment[env];
